export class Link {
  private text: string;
  private link: string;

  constructor(text: string, link: string) {
    this.text = text;
    this.link = link;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui-library/link/link.model.ts